import { render, staticRenderFns } from "./ErrorOpenedIssue.vue?vue&type=template&id=4dfb82bc&scoped=true&"
import script from "./ErrorOpenedIssue.vue?vue&type=script&lang=js&"
export * from "./ErrorOpenedIssue.vue?vue&type=script&lang=js&"
import style0 from "./ErrorOpenedIssue.vue?vue&type=style&index=0&id=4dfb82bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb82bc",
  null
  
)

export default component.exports